var Banners = $.extend(false, BaseModule ,{
    api_route : 'banners',

    data : {
        module      : 'banners',
        page        : 1,
        limit            : 20,
        with        : 'file',
        view        : 'list',
        pagination  : true
    },

    add_location : function (){
        var html_template = $('.locations-select-template').html();
        var markup = $('<div style="clear:both;" class="formRow">'+html_template+'</div>');
        $('.locations-list').append(markup).fadeIn('slow');
        initForm('.locations-list .formRow:last');
        if($('.locations-list .formRow').length == 1){
            $('.remove-locations-trigger').hide();
        }else{
            $('.remove-locations-trigger').show();
        }
    },

    init:function(){
        var module_name = this.data.module,  module = this;
    }
});

$(document).ready(function(){
    "use strict";
    Banners.init();
});
